import * as React from 'react'

import { useDepositsList } from './hooks'
import { Card, Tag } from 'antd'
import { CCol, CRow } from '@coreui/react-pro'
import {
  buttonColorTransactionRequestStatus,
  humanTransactionRequestStatus,
} from '../../../billing/const'
import { path } from '../../../../libs'

type Props = {
  entityId: string
}

export const DepositList = ({ entityId }: Props) => {
  const { deposits } = useDepositsList({ entityId })
  return (
    <CRow>
      {deposits?.map((item) => {
        return (
          <Card
            className="mb-2"
            key={item.transactionId}
            title={item.updatedAt}
          >
            <CRow>
              <CCol>
                <Tag
                  style={{
                    color: buttonColorTransactionRequestStatus(item.status)
                      .text,
                    backgroundColor: buttonColorTransactionRequestStatus(
                      item.status,
                    ).background,
                  }}
                  title={item.status}
                >
                  {humanTransactionRequestStatus(item.status)}
                </Tag>
              </CCol>{' '}
              {item.transactionId != '' && (
                <CCol>
                  ID:{' '}
                  <a
                    href={path.billing.deposit.edit(item.transactionId)}
                    target="_blank"
                  >
                    {item.transactionId}
                  </a>
                </CCol>
              )}
              {item?.rejectReason?.length > 0 && (
                <CCol>rejectReason: {item.rejectReason}</CCol>
              )}
              {item.psComment?.length > 0 && (
                <CCol>psComment: {item?.psComment}</CCol>
              )}
              {item.managerComment?.length > 0 && (
                <CCol>managerComment: {item.managerComment}</CCol>
              )}
              {item.internalComment?.length > 0 && (
                <CCol>internalComment: {item?.internalComment}</CCol>
              )}
              <CCol>initialAmount: {item?.initialAmount}</CCol>
            </CRow>
          </Card>
        )
      })}
    </CRow>
  )
}
